import React from "react";
import PropTypes from "prop-types";
import { asNumber } from "react-jsonschema-form/lib/utils";

const NumberField = (props) => {
  const { StringField } = props.registry.fields;
  const _onChange = (value) => {
    if(value === '') {
      props.onChange(value);
    } else {
      props.onChange(asNumber(value));
    }
  };

  return (
    <StringField {...props} onChange={_onChange} />
  );
}

NumberField.propTypes = {
  schema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object,
  idSchema: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  formData: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  required: PropTypes.bool,
  registry: PropTypes.object.isRequired,
  formContext: PropTypes.object.isRequired,
};

NumberField.defaultProps = {
  uiSchema: {},
};

export default NumberField;


// WEBPACK FOOTER //
// ./src/modules/common/components/form/fields/NumberField.js